module.exports = __webpack_public_path__ + "static/media/carriers-placeholder.2ff711b8.webp";